"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardBadgeArea = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _PropertyCardBadgeArea = require("./PropertyCardBadgeArea.styles");
/**
 * A container for the badge in a `PropertyCard`.
 *
 * @since 8.67.
 */
var PropertyCardBadgeArea = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(_PropertyCardBadgeArea.StyledPropertyCardBadgeArea, (0, _extends2.default)({
    ref: forwardedRef
  }, props));
});
exports.PropertyCardBadgeArea = PropertyCardBadgeArea;
PropertyCardBadgeArea.displayName = 'PropertyCard.BadgeArea';